// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__i0XhJ","content":"RecentSearches_content__1tMpv"};